/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/jsx-key */
import {IconBox} from '../../featured/Boxicon/IconBox';
import {Sort} from '../../featured/Sort.client';
import { useFilterUI } from '../../product';
import {useCallback} from 'react';

export function ChangeLayoutBar({}) {
  return (
    <section className="flex  items-center justify-end ">
      <div className="flex items-center -space-x-3">
        <Sort className="hidden lg:flex"/>
        <ViewLayoutColumn className="hidden lg:flex pb-1.5 place-items-evenly"/>
      </div>
    </section>
  );
}

function ViewLayoutColumn({className}){
  const layouts = [3, 2, 1];
  const {updateViewColumns} = useFilterUI();
  const handleChangeColumn = useCallback((value)=>(updateViewColumns(value)), [updateViewColumns]);
  return (
    <article className={className}>
      <div className="space-x-2 ">
        {layouts.map((value) => (
          <button
            onClick={() => handleChangeColumn(value)}
            className="Grid-view-tab"
            key={'button' + value}
          >
            <DotBox key={'dotbox' + value} value={value}/>
          </button>
        ))}
      </div>
    </article>
  );
}

function DotBox({value}) {
  const { viewColumns } = useFilterUI();
  return (
    <IconBox classExtra={`${viewColumns===value?'bg-slate-200/70':'bg-white '} duration-300 hover:bg-slate-200/90`}>
      <span
        aria-labelledby="View"
        className={`grid grid-cols-${value} place-items-evenly gap-[0.135rem] justify-center p-1.5 `}
      >
        {[...Array(value * 3)].map((v, index) => (
          <span
            key={index}
            className={`h-[0.30rem] w-[0.30rem] rounded-full ${
              viewColumns === value ? 'bg-slate-500' : 'bg-[#D2D2D2]'
            } group-active:[bg-slate-500] group-hover:bg-slate-500`}
         />
          ))}
      </span>
    </IconBox>
  );
}
